/* Covenant Craft site preview — behaviors. Cart and forms are local stand-ins; nothing talks to Shopify. */
(function () {
  var d = document, root = d.documentElement;
  root.classList.add('js');
  var P = window.CC_PACKAGES || {};
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, c) { return (c || d).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); };
  var money = function (n) { return '$' + (n % 1 ? n.toFixed(2) : n.toFixed(0)); };

  /* announcement rotator */
  var ann = $('#ann');
  if (ann && !reduce) setInterval(function () { ann.classList.toggle('alt'); }, 4200);

  /* mobile menu */
  var mb = $('#menu-btn'), mn = $('#mnav');
  if (mb && mn) {
    mb.addEventListener('click', function () {
      var o = mn.classList.toggle('open'); mb.setAttribute('aria-expanded', o); root.style.overflow = o ? 'hidden' : '';
    });
    $$('a', mn).forEach(function (a) { a.addEventListener('click', function () { mn.classList.remove('open'); root.style.overflow = ''; mb.setAttribute('aria-expanded', false); }); });
  }

  /* reveal on scroll */
  var rv = $$('.rv');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    rv.forEach(function (e) { io.observe(e); });
  } else rv.forEach(function (e) { e.classList.add('is-in'); });

  /* accordions */
  $$('.acc-btn').forEach(function (b) {
    b.addEventListener('click', function () {
      var p = d.getElementById(b.getAttribute('aria-controls')), o = b.getAttribute('aria-expanded') !== 'true';
      b.setAttribute('aria-expanded', o); p.classList.toggle('open', o);
    });
  });

  /* pinned material words: light one line per scroll step, raise and turn the mold */
  var nums = $('#nums'), list = $$('#nums-list li'), shot = $('#nums-shot');
  function onNums() {
    if (!nums) return;
    var r = nums.getBoundingClientRect(), span = r.height - innerHeight;
    var t = span > 0 ? Math.min(1, Math.max(0, -r.top / span)) : 1;
    list.forEach(function (li, i) { li.classList.toggle('lit', t >= i / list.length - 0.02 && r.top < innerHeight * 0.6); });
    if (shot) { shot.style.setProperty('--rise', (70 - 70 * t) + '%'); shot.style.setProperty('--turn', (16 * t) + 'deg'); }
  }

  /* parallax: elements with data-par="0.2" drift against the scroll */
  var pars = reduce ? [] : $$('[data-par]');
  function onPar() {
    var vh = innerHeight;
    pars.forEach(function (el) {
      var host = el.parentNode.getBoundingClientRect();
      if (host.bottom < -200 || host.top > vh + 200) return;
      var mid = host.top + host.height / 2 - vh / 2;
      el.style.setProperty('--py', (-mid * parseFloat(el.getAttribute('data-par'))).toFixed(1) + 'px');
    });
  }

  /* footer giant wordmark slides in */
  var giant = $('.ftr-giant');
  function onGiant() {
    if (!giant || reduce) return;
    var r = giant.getBoundingClientRect();
    var t = Math.min(1, Math.max(0, (innerHeight - r.top) / (innerHeight * 0.7)));
    giant.style.setProperty('--gx', ((1 - t) * -60).toFixed(1) + 'px');
  }

  /* sticky bar: after the hero, hidden over the footer */
  var sbar = $('#sbar'), hero = $('.hero, .pdp, .phead'), ftr = $('.ftr');
  function onSbar() {
    if (!sbar) return;
    var past = hero ? hero.getBoundingClientRect().bottom < 80 : scrollY > 400;
    var atEnd = ftr && ftr.getBoundingClientRect().top < innerHeight - 40;
    sbar.classList.toggle('show', past && !atEnd && !root.classList.contains('cart-open'));
  }
  var tick = false;
  function onScroll() { if (tick) return; tick = true; requestAnimationFrame(function () { onNums(); onPar(); onGiant(); onSbar(); tick = false; }); }
  addEventListener('scroll', onScroll, { passive: true }); addEventListener('resize', onScroll);
  onNums(); onPar(); onGiant(); onSbar();

  /* PDP image: gentle tilt toward the pointer */
  $$('.gal-stage').forEach(function (g) {
    if (reduce || !matchMedia('(hover:hover)').matches) return;
    var im = $('img', g);
    g.addEventListener('pointermove', function (e) {
      var r = g.getBoundingClientRect();
      im.style.setProperty('--ty', (((e.clientX - r.left) / r.width - .5) * 10).toFixed(2) + 'deg');
      im.style.setProperty('--tx', ((.5 - (e.clientY - r.top) / r.height) * 10).toFixed(2) + 'deg');
    });
    g.addEventListener('pointerleave', function () { im.style.setProperty('--tx', '0deg'); im.style.setProperty('--ty', '0deg'); });
  });

  /* mold filter chips */
  $$('.chip[data-f]').forEach(function (c) {
    c.addEventListener('click', function () {
      $$('.chip[data-f]').forEach(function (x) { x.setAttribute('aria-pressed', x === c); });
      var f = c.getAttribute('data-f');
      $$('.shop-grid .pcard').forEach(function (p) { p.hidden = !(f === 'all' || (p.getAttribute('data-kind') || '').split(' ').indexOf(f) > -1); });
    });
  });

  /* ---------- scroll-scrub demold showcase ---------- */
  (function () {
    var el = $('#scrub'); if (!el) return;
    var canvas = $('canvas', el), ctx = canvas && canvas.getContext && canvas.getContext('2d');
    if (reduce || !ctx) return;
    var N = parseInt(el.dataset.frames, 10) || 60, tpl = el.dataset.src, W = 1200, H = 900;
    canvas.width = W; canvas.height = H;
    var copy = $('.scrub-copy', el), frames = new Array(N), loaded = new Array(N), started = false, drawn = -1, lastC = -1, want = 0;
    function url(i) { var s = String(i); while (s.length < 3) s = '0' + s; return tpl.replace(/\{n\}|NNN/, s); }
    function load(i) {
      if (frames[i]) return;
      var im = new Image(); im.decoding = 'async';
      im.onload = function () { loaded[i] = true; if (drawn === -1 || i === want) step(true); };
      im.onerror = function () { if (i === 0) el.classList.remove('is-scroll'); };   /* no frames yet: fall back to the still */
      im.src = url(i); frames[i] = im;
    }
    function loadRest() {
      if (started) return; started = true; load(N - 1);
      var i = 1; (function next() { for (var k = 0; k < 6 && i < N - 1; k++) load(i++); if (i < N - 1) setTimeout(next, 60); })();
    }
    function nearest(i) { for (var k = 0; k < N; k++) { if (i - k >= 0 && loaded[i - k]) return i - k; if (i + k < N && loaded[i + k]) return i + k; } return -1; }
    function progress() {
      var r = el.getBoundingClientRect(), vh = innerHeight, lead = vh * 0.35, total = r.height - vh + lead;
      return total <= 0 ? 1 : Math.min(1, Math.max(0, (lead - r.top) / total));
    }
    function step(force) {
      var p = progress();
      want = Math.min(N - 1, Math.round(Math.min(1, p / 0.66) * (N - 1)));
      var i = nearest(want);
      if (i !== -1 && (i !== drawn || force)) { ctx.clearRect(0, 0, W, H); ctx.drawImage(frames[i], 0, 0, W, H); drawn = i; }
      var c = Math.round(Math.min(1, Math.max(0, (p - 0.5) / 0.25)) * 100) / 100;
      if (c !== lastC) { el.style.setProperty('--scrub-copy', c); lastC = c; }
      el.style.setProperty('--scrub-p', p.toFixed(3));
    }
    var raf = 0; function loop() { step(false); raf = requestAnimationFrame(loop); }
    el.classList.add('is-scroll'); load(0);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        if (es[0].isIntersecting) { loadRest(); if (!raf) loop(); } else if (raf) { cancelAnimationFrame(raf); raf = 0; step(true); }
      }, { rootMargin: '100% 0px 100% 0px' }).observe(el);
    } else { loadRest(); loop(); }
  })();

  /* ---------- cart (packages) ---------- */
  var KEY = 'cc-preview-cart', cart = { items: [] };
  try { cart = JSON.parse(localStorage.getItem(KEY)) || cart; } catch (e) {}
  function save() { try { localStorage.setItem(KEY, JSON.stringify(cart)); } catch (e) {} }
  function add(id) {
    if (!P[id]) return;
    var f = cart.items.filter(function (i) { return i.id === id; })[0];
    if (f) f.qty += 1; else cart.items.push({ id: id, qty: 1 });
    save(); render(); open();
  }
  function open() { root.classList.add('cart-open'); onSbar(); var x = $('.cart-x'); if (x) x.focus(); }
  function close() { root.classList.remove('cart-open'); onSbar(); }
  function render() {
    var box = $('#cart-items'); if (!box) return;
    var n = 0, sub = 0;
    cart.items = cart.items.filter(function (i) { return P[i.id] && i.qty > 0; });
    box.innerHTML = cart.items.length ? cart.items.map(function (it, k) {
      var p = P[it.id]; n += it.qty; sub += p.price * it.qty;
      return '<div class="citem"><div><b>' + p.name + '</b><small>' + p.line + '</small><span class="cq"><button type="button" data-k="' + k + '" data-dq="-1" aria-label="One less">−</button><span>' +
        it.qty + '</span><button type="button" data-k="' + k + '" data-dq="1" aria-label="One more">+</button></span></div><div><div class="cp">' + money(p.price * it.qty) +
        '</div><button class="crm" type="button" data-k="' + k + '" data-dq="-999">Remove</button></div></div>';
    }).join('') : '<p class="cart-empty">Nothing in here yet.<br>Pick a package or start a quote.</p>';
    $$('.hdr-count').forEach(function (c) { c.textContent = n; });
    var st = $('#cart-sub'); if (st) st.textContent = money(sub);
    var co = $('#cart-co'); if (co) co.toggleAttribute('disabled', !n);
  }
  d.addEventListener('click', function (e) {
    var t = e.target.closest('[data-add],[data-cart-open],[data-cart-close],[data-dq]'); if (!t) return;
    if (t.hasAttribute('data-add')) { e.preventDefault(); add(t.getAttribute('data-add')); }
    else if (t.hasAttribute('data-cart-open')) { e.preventDefault(); open(); }
    else if (t.hasAttribute('data-cart-close')) close();
    else if (t.hasAttribute('data-dq') && t.hasAttribute('data-k')) {
      var it = cart.items[+t.getAttribute('data-k')]; if (it) { it.qty += +t.getAttribute('data-dq'); save(); render(); }
    }
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  render();

  /* quote form: file drop label + stub submit */
  $$('.drop').forEach(function (dz) {
    var inp = $('input', dz), lab = $('span', dz);
    if (!inp) return;
    inp.addEventListener('change', function () { if (inp.files.length) lab.textContent = inp.files.length === 1 ? inp.files[0].name : inp.files.length + ' files chosen'; });
    ['dragenter', 'dragover'].forEach(function (ev) { dz.addEventListener(ev, function (e) { e.preventDefault(); dz.classList.add('over'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { dz.addEventListener(ev, function (e) { e.preventDefault(); dz.classList.remove('over'); }); });
    dz.addEventListener('drop', function (e) { if (e.dataTransfer.files.length) { inp.files = e.dataTransfer.files; inp.dispatchEvent(new Event('change')); } });
  });
  /* prefill the quote form from ?mold= */
  var q = new URLSearchParams(location.search).get('mold'), sel = $('#q-type');
  if (q && sel) $$('option', sel).forEach(function (o) { if (o.value === q) sel.value = q; });
  var qp = new URLSearchParams(location.search).get('package'), selp = $('#q-pack');
  if (qp && selp) $$('option', selp).forEach(function (o) { if (o.value === qp) selp.value = qp; });
  $$('form[data-stub]').forEach(function (f) {
    f.addEventListener('submit', function (e) { e.preventDefault(); var n = $('.stub-note', f); if (n) n.hidden = false; });
  });
})();

/* Klaviyo (added 2026-10-05): the custom mold inquiry form also sends the event "CC Quote Requested" to the Davision
   Klaviyo account (UneZNa), which starts the "[CC] Quote received" emails. It does NOT subscribe the person to the
   newsletter: asking for a quote is not a newsletter signup. The Shopify contact form still submits as before. */
(function () {
  var form = document.querySelector('form#inquire');
  if (!form) return;
  form.addEventListener('submit', function () {
    var val = function (n) { var el = form.querySelector('[name="contact[' + n + ']"]'); return el && el.value ? String(el.value).trim().slice(0, 500) : ''; };
    var email = val('email');
    if (!email) return;
    var name = val('Name'), pack = val('Package');
    var profile = { email: email, properties: { cc_signup: 'yes', cc_package: pack || 'custom', cc_company: val('Brand'), cc_phone: val('phone') } };
    if (name) profile.first_name = name.split(' ')[0];
    var body = { data: { type: 'event', attributes: {
      properties: { brand: 'covenant-craft', name: name, company: val('Brand'), phone: val('phone'), pouring: val('Pouring'), mold_type: val('Mold type'), 'package': pack || 'custom',
        piece_size: val('Piece size'), cavities_and_trays: val('Cavities and trays'), file_link: val('File link'), notes: val('body'), url: location.origin + location.pathname },
      metric: { data: { type: 'metric', attributes: { name: 'CC Quote Requested' } } },
      profile: { data: { type: 'profile', attributes: profile } } } } };
    try {
      fetch('https://a.klaviyo.com/client/events/?company_id=UneZNa', { method: 'POST', keepalive: true,
        headers: { 'content-type': 'application/vnd.api+json', revision: '2025-07-15' }, body: JSON.stringify(body) });
    } catch (e) {}
  });
})();
